import React from 'react';
import { useOrganizationById } from '@/clients/organization/useOrganization.ts';
import { useSuspenseConstructionProject } from '@/clients/constructionProject/useConstructionProject.ts';
import { SectionSummaryContent, SectionSummaryContentItem } from '@/shared/components/SectionSummary.tsx';
import { useTranslation } from 'react-i18next';

interface ClientInformationSummaryProps {
    organizationId: number;
    constructionProjectId: string;
    manualCostCenter?: string | null;
    sourceCostCenter?: string | null;
}

export const ClientInformationSummary = ({
    organizationId,
    constructionProjectId,
    manualCostCenter,
    sourceCostCenter,
}: ClientInformationSummaryProps) => {
    const { t } = useTranslation();
    const { data: organization } = useOrganizationById(organizationId);
    const { data: constructionProject } = useSuspenseConstructionProject(constructionProjectId);

    const effectiveCostCenter = manualCostCenter ?? sourceCostCenter ?? constructionProject.costCenter;

    const sectionSummaryContentList: SectionSummaryContentItem[] = [
        { label: t('sections.clientInformation.client'), value: organization.name },
        { label: t('selectConstructionProject.label'), value: constructionProject.name },
        ...(effectiveCostCenter
            ? [{ label: t('sections.clientInformation.manualCostCenterLabel'), value: effectiveCostCenter }]
            : []),
    ];

    return <SectionSummaryContent sectionSummaryContentList={sectionSummaryContentList} />;
};
